import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { throttle } from 'src/lib/utils';
import { ConfirmDialog } from './ConfirmDialog';

interface CommonDialogProps {
  title: string;
  description: string;
}

export const CommonDialog: React.FC<CommonDialogProps> = ({ title, description }) => {
  const { t } = useTranslation('translation');
  const history = useHistory();
  const handleOKClick = useCallback(
    throttle(() => {
      history.goBack();
    }, 1000),
    [history]
  );

  return (
    <ConfirmDialog
      title={title}
      description={description}
      confirmLabel={t('dialog_button_ok')}
      onConfirmClick={handleOKClick}
    />
  );
};
